/**
 * In-memory impersonation token store.
 *
 * SECURITY: The token is intentionally never written to any persistent storage
 * (localStorage, sessionStorage, cookies, IndexedDB). It lives only in this
 * module-scoped variable and is lost on page reload — that is by design.
 */
let _token: string | null = null

export const setToken = (t: string): void => {
  _token = t
}

export const getToken = (): string | null => _token

export const clearToken = (): void => {
  _token = null
}

export const hasToken = (): boolean => _token !== null
